import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import { makeAssetTypeTree } from './assetSelectors';
import TieredSelect from '../common/lookups/tieredSelect';
import Loader from '../common/loader';
const AssociatedAssetTypeFilter = ({
  assetsLoading,
  associatedAssetType: {
    indexQuery,
    loading: typesLoading
  },
  associatedAssetTypeActions: {
    serverFilter
  },
  categoryTypeOptions,
  filters: _filters = {},
  onAdd,
  onBack,
  onFilter
}) => {
  // requery whenever filters change
  useEffect(() => {
    serverFilter(_filters, indexQuery);
  }, [_filters, indexQuery, serverFilter]);
  const handleChange = (selectedValues, newValue) => {
    const filterName = newValue.entity;
    if (filterName === 'assetCategoryName' || filterName === 'assetType') {
      let currentFilters = _filters[filterName] ? _filters[filterName] : [];
      if (currentFilters.some(at => at.id === newValue.id)) {
        // remove this from the list
        currentFilters = currentFilters.filter(at => at.id !== newValue.id);
      } else {
        const newFilter = {
          id: newValue.id,
          name: newValue.name
        };
        currentFilters = [newFilter];
      }
      onFilter(filterName, currentFilters);
    } else if (filterName === 'asset') {
      onAdd(newValue);
    }
  };
  let selections = [];
  if (_filters) {
    if (_filters.assetCategoryName) {
      selections = _filters.assetCategoryName;
    }
    if (_filters.assetType) {
      selections = selections.concat(_filters.assetType);
    }
  }
  return /*#__PURE__*/React.createElement(TieredSelect, {
    style: {
      minHeight: 100
    },
    label: "Category / Type",
    data: categoryTypeOptions,
    value: selections,
    onBack: onBack,
    onChange: handleChange,
    backLabel: "Back",
    multi: true
  }, assetsLoading || typesLoading ? /*#__PURE__*/React.createElement(Loader, {
    style: {
      margin: '20px auto',
      fontSize: '5px'
    }
  }) : null);
};
AssociatedAssetTypeFilter.propTypes = {
  assetsLoading: PropTypes.bool.isRequired,
  filters: PropTypes.shape({
    assetCategoryName: PropTypes.arrayOf(PropTypes.shape({})),
    assetType: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  associatedAssetType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})),
    loading: PropTypes.bool
  }).isRequired,
  associatedAssetTypeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  categoryTypeOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onFilter: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired
};
export { AssociatedAssetTypeFilter as TestAssociatedAssetTypeFilter };
export default entityComposition(AssociatedAssetTypeFilter, ['associatedAssetType'], {
  categoryTypeOptions: state => makeAssetTypeTree(state.associatedAssetType.list, state.associatedAsset.list)
});